import React, { useEffect, useState } from "react";
import OnboardSuccess from "../../components/onboardSuccess";
import createPersistedState from "use-persisted-state";
import { useHistory } from "react-router-dom";
import { useTranslation } from "react-i18next";

//TODO: To refactor
const usePIDState = createPersistedState("pid");

function CongratulationsStep({ qKey, onSubmitHandler, profile }) {
  const _qKey = qKey;
  const [pid, setPID] = usePIDState();
  const [username, setUsername] = useState();
  const history = useHistory();
  const { i18n } = useTranslation();

  useEffect(() => {
    setUsername(pid);
  }, [pid]);

  const onNextFn = (data) => {
    // redirect to set password
    onSubmitHandler({ [_qKey]: data });
    //nextStep();
    //Clear everything except locale
    localStorage.removeItem("onboardingState");
    localStorage.removeItem("onboardingStep");
    history.push("/password");
  };

  return (
    <>
      <OnboardSuccess patientId={username} onSubmitHandler={onNextFn} />
    </>
  );
}

export default CongratulationsStep;
